import React from 'react';
import PropTypes from 'prop-types';
import { SchemaOrg } from 'project/schema-org';

export default class QualifiedPlayerCard extends React.PureComponent {
    getLinkAriaLabel() {
        return `${this.props.item.firstName} ${this.props.item.lastName}`;
    }

    render() {
        const item = this.props.item;
        const subtitleModCss = item.lastName.length > 8 ? 'qualified-player-card__subtitle--small' : '';

        return (
            <a href={item.playerURL} aria-label={this.getLinkAriaLabel()}
                className={`qualified-player-card qualified-player-card--bg-${this.props.bg} ${!item.isPlaying ? 'is-not-playing' : ''}`}>
                <div className="qualified-player-card__header">
                    {item.championOfTheYears.length > 0 ?
                        <div className="qualified-player-card__champion">
                            <img className="qualified-player-card__logo"
                                src="/images/logo-symbol-silver.png"
                                alt="the open"
                                width="18"
                                height="18" />
                            <ul>
                                {item.championOfTheYears.map((year) =>
                                    <li key={year}>{year}</li>)}
                            </ul>
                        </div> : null}
                    {
                        item.flag &&
                        <img className="qualified-player-card__flag lazyload"
                            data-src={item.flag.src} alt="" />
                    }
                </div>
                <div className="qualified-player-card__photo">
                    {item.playerImageSrcSet ?
                        <img data-srcset={item.playerImageSrcSet} data-sizes="auto"
                            className="lazyload" alt="" /> :
                        null}
                </div>
                <div className="qualified-player-card__footer">
                    {!item.isPlaying ? (
                        <div className="qualified-player-card__not-playing">
                            Not Playing - <span className="qualified-player-card__missing-reason">
                                {item.missingReason}
                            </span>
                        </div>
                    ) : null}
                    <h3>
                        <span className="qualified-player-card__title">{item.firstName}</span>
                        <span className={`qualified-player-card__subtitle ${subtitleModCss}`}>
                            {
                                item.lastName
                            }
                            {
                                item.isAmateur ? <span className="qualified-player-card__amateur"> (a)</span> : null
                            }
                            {
                                item.isReinstatedAmateur ? <span className="qualified-player-card__amateur"> (a/r)</span> : null
                            }
                        </span>
                    </h3>
                </div>
                <SchemaOrg model={item.schemaOrg.person} />
            </a>
        );
    }
}

QualifiedPlayerCard.propTypes = {
    item: PropTypes.object.isRequired,
    bg: PropTypes.number
};
